import * as React from "react"
import { connect } from "react-redux"
import trans, { isTrans } from "trans"

import {
    GridCell,
    FieldLabel,
    Icon,
    Theme,
    Checkbox,
    Button,
    Select,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue,
} from "app/reducers/form";

import { CustomStatusOption, isMultiSelectCloseOnChange, StyledSliderDiv } from "./filters";
import { allowObjectToImageRatioForUsers } from "template-edit/components/helper";
import { isGodModeOn } from "app/helpers/api";
import { Slider } from "@mui/material";
import { ReduxList } from "app/types/app-types";
import { AvailableOptionsType } from "../types";
import { FiltersFormType } from "../types/filtertypes";
import { ColorModelType } from "./basic-filters";
import { selectFormValues } from "app/reducers/form";
import { StyledInputGroupFilter } from "shape-edit/forms/fields";

interface Props {
    setIsDirty: Function
    userId: number
    updateInputValue: typeof updateInputValue
    availableOptions: ReduxList<AvailableOptionsType>
    filtersForm: FiltersFormType
}

class ImageFilters extends React.Component<Props> {
    constructor(props: Props) {
        super(props)
    }

    render() {
        const { availableOptions, filtersForm, userId } = this.props
        const [objectToImageFrom, objectToImageTo] = filtersForm && filtersForm.image && filtersForm.image.object_to_image_ratio ? filtersForm.image.object_to_image_ratio.split('_') : ['', '']

        const availableStatusCodes = availableOptions.data && availableOptions.data.available_status_codes ?
            availableOptions.data.available_status_codes.map((o: number) => {
                const color = o === 200 ? Theme.green : (o >= 500 ? Theme.red : Theme.orange)
                const transString = `status_${o}_0`
                const label = o !== null ? ((o === 0 ? '' : `${o}:`) + (isTrans(transString) ? ` ${trans(transString).toLowerCase()}` : `Status ${o}`)) : ''
                return {
                    label: label,
                    text: <Icon type={'circle'} text={label} color={color} />,
                    value: o !== null ? o.toString() : '',
                }
            }) : null


        const availableMimeTypes = availableOptions.data && availableOptions.data.available_mime_types ?
            availableOptions.data.available_mime_types.map((o: string) => {
                return {
                    label: `${o}`,
                    value: `${o}`
                }
            }) : null

        const availableColorModels = availableOptions.data && availableOptions.data.available_color_models ?
            availableOptions.data.available_color_models.map((o: ColorModelType) => {
                return {
                    label: `${o.label}`,
                    value: `${o.value}`
                }
            }) : null

        const isAllowSpecialFields = (allowObjectToImageRatioForUsers.includes(userId) || isGodModeOn)

        const isPersonFromNull = typeof filtersForm.person?.max_confidence?.from === "undefined" || filtersForm.person?.max_confidence?.from === null
        const filterPersonFrom = isPersonFromNull ? 50 : parseInt(`${filtersForm.person?.max_confidence?.from}`)


        return (
            <>
                {availableStatusCodes &&
                    <GridCell className={filtersForm.image.status_code && Array.isArray(filtersForm.image.status_code) && filtersForm.image.status_code.length > 0 ? "active-filter" : ''}>
                        <Select
                            name={`filtersForm.image.status_code`}
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            options={availableStatusCodes}
                            OptionComponent={CustomStatusOption}
                            label={<Icon type={'circle'} text={trans('filter_status_code')} />}
                            onChange={(value) => {
                                this.props.setIsDirty(true)
                                this.props.updateInputValue('filtersForm', 'image.status_code', value)
                            }}
                        />
                    </GridCell>
                }

                {availableMimeTypes &&
                    <GridCell className={filtersForm.image.content_type && Array.isArray(filtersForm.image.content_type) && filtersForm.image.content_type.length > 0 ? "active-filter" : ''}>
                        <Select
                            name={`filtersForm.image.content_type`}
                            multiple={true}
                            closeOnChange={isMultiSelectCloseOnChange}
                            options={availableMimeTypes}
                            label={<Icon type="file-image-o" text={trans('filter_content_type')} />}
                        />


                        {/* <StyledInputGroupFilter
                            formName='filtersForm.image.content_type'
                            singleChoice={false}
                            onChange={() => this.props.setIsDirty(true)}
                            transString={'filter_content_type'}
                            iconType={'file-image-o'}
                            showClear={filtersForm.image?.content_type && Array.isArray(filtersForm.image.content_type) && filtersForm.image.content_type.length > 0}
                            items={availableMimeTypes}
                            onClear={() => {
                                this.props.updateInputValue('filtersForm', 'image.content_type', null)
                                this.props.setIsDirty(true)
                            }}
                        /> */}
                    </GridCell>
                }

                {availableColorModels &&
                    <GridCell className={filtersForm.image.color_space && Array.isArray(filtersForm.image.color_space) && filtersForm.image.color_space.length > 0 ? "active-filter" : ''}>
                        <StyledInputGroupFilter
                            formName='filtersForm.image.color_space'
                            singleChoice={false}
                            onChange={() => this.props.setIsDirty(true)}
                            transString={'not_recommended_colorspace'}
                            iconType={'colours-light'}
                            showClear={filtersForm.image?.color_space && Array.isArray(filtersForm.image.color_space) && filtersForm.image.color_space.length > 0}
                            items={availableColorModels}
                            onClear={() => {
                                this.props.updateInputValue('filtersForm', 'image.color_space', null)
                                this.props.setIsDirty(true)
                            }}
                        />
                    </GridCell>
                }

                <GridCell className={filtersForm.image.orientation && Array.isArray(filtersForm.image.orientation) && filtersForm.image.orientation.length > 0 ? "active-filter" : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.image.orientation'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'orientation'}
                        iconType={'rotate-counter-clockwise-radix'}
                        showClear={filtersForm.image?.orientation && Array.isArray(filtersForm.image.orientation) && filtersForm.image.orientation.length > 0}
                        items={[
                            { label: trans('portrait'), value: 'portrait' },
                            { label: trans('landscape'), value: 'landscape' },
                            { label: trans('square'), value: 'square' },
                        ]}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'image.orientation', null)
                            this.props.setIsDirty(true)
                        }}
                    />
                </GridCell>

                <GridCell className={filtersForm.person?.max_confidence?.from ? "active-filter" : ''}>
                    <StyledSliderDiv>
                        <FieldLabel><Icon type="person-light" text={trans('has_person')} /></FieldLabel>

                        {!isPersonFromNull &&
                            <span style={{ position: 'absolute', right: '10px' }} className='clickable' onClick={() => this.props.updateInputValue('filtersForm', 'person.max_confidence', null)}>
                                <Icon type={'close-light'} color={'#3a3a3a'} />
                            </span>
                        }

                        <Slider
                            value={filterPersonFrom}
                            onChange={(event: Event, value: number[]) => {
                                this.props.updateInputValue('filtersForm', 'person', {
                                    ...filtersForm.person,
                                    max_confidence: {
                                        from: value,
                                    },
                                })
                                this.props.setIsDirty(true)
                            }}
                            color={isPersonFromNull ? 'secondary' : 'primary'}
                            track={"inverted"}
                            step={1}
                            min={0}
                            max={100}
                            marks={[{ value: 0, label: '0%' }, { value: 15 }, { value: 25, label: '25%' }, { value: 75 }, { value: 100, label: '100%' }]}
                            valueLabelDisplay="auto"
                            getAriaLabel={() => `${trans('confidence')} [%]`}
                            getAriaValueText={(value) => `${value}%`}
                            valueLabelFormat={(value) => `${value}%`}
                        />
                    </StyledSliderDiv>
                </GridCell>

                {isAllowSpecialFields &&
                    <GridCell className={'some-users-only'}>
                        <Checkbox
                            name={`filtersForm.image.should_redownload`}
                            onValue={1}
                            offValue={0}
                            label={<Icon type={'download-radix'} text={trans('should_redownload')} />}
                            onChange={() => this.props.setIsDirty(true)}
                        />
                    </GridCell>
                }

                {isAllowSpecialFields &&
                    <GridCell className={'some-users-only'}>
                        <FieldLabel><Icon type="margin-radix" text={`${trans('object_to_image_ratio')} [%]`} /></FieldLabel>
                        <StyledSliderDiv>
                            <Slider
                                value={[objectToImageFrom ? parseInt(`${objectToImageFrom}`) : 0, objectToImageTo ? parseInt(`${objectToImageTo}`) : 100]}
                                onChange={(event: Event, value: number[]) => {
                                    this.props.updateInputValue('filtersForm', 'image.object_to_image_ratio', `${value[0] ?? 0}_${value[1] ?? 100}`)
                                    this.props.setIsDirty(true)
                                }}
                                step={1}
                                min={0}
                                max={100}
                                color={filtersForm.image.object_to_image_ratio ? 'primary' : 'secondary'}
                                /*marks={[{value: 0},{value: 25},{value: 50},{value: 75},{value: 100}]}*/
                                valueLabelDisplay="auto"
                                getAriaLabel={() => `${trans('object_to_image_ratio')} [%]`}
                                getAriaValueText={(value) => `${value}%`}
                            /*valueLabelFormat={(value) => `${value}%`}*/
                            />
                        </StyledSliderDiv>
                    </GridCell>
                }
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        availableOptions: state.availableOptions,
        filtersForm: selectFormValues(state, 'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(ImageFilters)
